module.exports = __webpack_public_path__ + "img/little_bunny_256.acf06fd5.png";